import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { Construction } from "@mui/icons-material";

const WorkInProgress = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
        bgcolor: "#f4f4f9",
        color: "#333",
        padding: 2,
      }}
    >
      <Construction sx={{ fontSize: 80, color: "#ff9800", mb: 2 }} />
      <Typography variant="h4" gutterBottom>
        Work in Progress
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        We're working hard to bring something amazing! Check back soon.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        href="/"
        sx={{ borderRadius: "8px", padding: "10px 20px" }}
      >
        Go Back to Home
      </Button>
    </Box>
  );
};

export default WorkInProgress;
